import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import * as FileSaver from 'file-saver';
import LoadingOverlay from "react-loading-overlay";

import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.png'
//import styled, { css } from "styled-components";

//import ReactGA from "react-ga4";




var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
var Dispatch_From_Date_val;
var dispatch_to_Date_val;
const Heading = [['Crate ID', 'Warehouse Code', 'Brand', "Bill ID", 'No. of unique SKUs', 'Total Bill Value', 'Subgroup ID',  'Bill Date', 'Dispatch Date', 'Total Volume of Prod' ]];




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);

    this.state = {

      filtered_orderData: "",
      loader1: false,
      isDisabledApply: false,
      fromdate: "",
      todate: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      bill_no: "",
      group_id: "",
      dispatchtodate : "",
      dispatchfromdate : "",
    };
  }

  onBillChange = (evt) => {
    this.setState({
      bill_no: evt.target.value.trim(),
    });
  };

  onGroupChange = (evt) => {
    this.setState({
      group_id: evt.target.value.trim(),
    });
  };


  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      fromdate: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }


  }

  ToDateChange = date => {

    this.setState({
      todate: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        todate: "",

      })
      to_Date_val = ""
    }

  }
  DispatchFromDateChange = date  => {
    this.setState({
      dispatchfromdate :  date,
      showFromErr: false

    })  
    if(date){
       Dispatch_From_Date_val = this.convertDate(date);
     }else{
      this.setState({
        dispatchfromdate: ""
      })
      Dispatch_From_Date_val = ""
     }
   
    
}

DispatchToDateChange = date => {
    
    this.setState({
      dispatchtodate :  date,
      showToErr: false
    }) 
    if(date){
      dispatch_to_Date_val = this.convertDate(date);
    }else{
      this.setState({
        dispatchtodate: "",
       
      })
       dispatch_to_Date_val= ""
    }
     
}

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var today = new Date();
    // From_Date_val = this.convertDate(today);
    // to_Date_val = this.convertDate(today);

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        //fromdate: today,
        //todate: today,

      },
      () => {

      }
    );

  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  assembleDispatchData = (dispatchData) => {

    let DispatchData = dispatchData.map((post, index) => {

      return {
        crate_id: post.crate,
        warehouse_code: post.warehouse_code,
        brand: post.client_code,
        bill_id: post.outlet_order_no,
        unique_sku :post.skus_count,
        total_bill_value : post.total_bill_value,
        total_volume_of_prod: post.total_volume,
        bill_date: post.bill_date,
        dispatch_date: post.dispatch_date,
        subgroup_id: post.ptl_id,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  fetchDispatch = (order_no) => {

  /*  ReactGA.event({
      category: "Report",
      action: "view",
      label: "SO TO Dispatch report", // optional
    });*/


    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    // var batch = localStorage.getItem('batch_id');
    const payload = {
      "order_to_date": to_Date_val,
      "order_from_date": From_Date_val,
      "dispatch_from_date":Dispatch_From_Date_val,
      "dispatch_to_date" : dispatch_to_Date_val,
      

    };
    addAnalytics('Report', 'View Packed Crate', payload);

    API.post('/product/packed-crates-report/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        if (data.success == false) {
          this.setState({
            failed_message: data.message
          })
          this.toggle();
        }


        if (data.length == 0) {

          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,

          });
          return false;
        }



        this.setState({
          orderData: data.data,
          filtered_orderData: data.data,
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) { });
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;

    const dispatchData = {
      columns: [
        {
          label: "Crate ID",

          field: "crate_id",
          width: 120,
        },

        {
          label: "Warehouse Code.",

          field: "warehouse_code",
          width: 130,
        },
        {
          label: "Brand",

          field: "brand",
          width: 120,
        },
        {
          label: "Bill ID",

          field: "bill_id",
          width: 120,
        },
        {
          label: "No. of Unique SKUs",

          field: "unique_sku",
          width: 160,
        },
        {
          label: "Total Bill Value",

          field: "total_bill_value",
          width: 140,
        },
        {
          label: "Total Volume of prod",

          field: "total_volume_of_prod",
          width: 150,
        },
        {
          label: "Bill Date",

          field: "bill_date",
          width: 120,
        },
        {
          label: "Dispatch Date",

          field: "dispatch_date",
          width: 130,
        },
        {
          label: "Subgroup ID",

          field: "subgroup_id",
          width: 120,
        },


       
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>

        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <Overlay>
            <form className="form" onSubmit={handleSubmit}>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Dispatch From Date</span>
                <div style={{ position: 'relative' }}>       
                  <DatePicker
                    selected={this.state.dispatchfromdate}
                    onChange={this.DispatchFromDateChange}
                    className="ledger_fromdate"
                    placeholderText="Dispatch From Date"
                    format='yyyy-MM-dd'
                  />
                  {this.state.showFromErr &&
                  <span style={{color: 'red', fontSize: 11}}>Please Select Dispatch From Date</span>
                  }
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title"> Dispatch To Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker 
                    selected={this.state.dispatchtodate}
                    onChange={this.DispatchToDateChange}
                    className="ledger_todate"
                    placeholderText="Dispatch To Date"
                  />
                  {this.state.showToErr &&
                    <span style={{color: 'red', fontSize: 11}}>Please Select Dispatch To Date</span>
                  }
                </div>
              </div>


              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Order From Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={this.state.fromdate}
                    onChange={this.FromDateChange}
                    className="ledger_fromdate"
                    placeholderText="Order From Date"
                    format='yyyy-MM-dd'
                  />
                  {this.state.showFromErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                  }
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title"> Order To Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={this.state.todate}
                    onChange={this.ToDateChange}
                    className="ledger_todate"
                    placeholderText="Order To Date"
                  />
                  {this.state.showToErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                  }
                </div>
              </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                  
                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        padding: "5px 25px",
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, "Packed Crate Report", Heading)}
                    >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '25px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>

          {!this.state.showFetchDispatchData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}
          {this.state.showFetchDispatchData && (
            <div>
              <div>
                {Dispatch_From_Date_val &&
                  <div className="date-container">
                   {Dispatch_From_Date_val}
                  </div>
                }

                {dispatch_to_Date_val &&
                  <div className="date-container">
                   {dispatch_to_Date_val}
                  </div>
                }

                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                } 

                {to_Date_val &&
                  <div className="date-container">
                   {to_Date_val}
                  </div>
                } 
              </div>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  <MDBDataTable
                    scrollX
                    scrollY
                    sortable={false}
                    maxHeight="390px"
                    displayEntries={false}
                    onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Packed Crate Report', 'datatable_pagination_change' )}
                    striped
                    onSearch={this.filterData}
                    bordered
                    data={dispatchData}
                  />
                </div>
              </div>
            </div>
          )}
        </Card>


      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
